export default {
  title: "Exceptions d'horaires",
  fields: {
    status: {
      label: 'Statut',
    },
    date: {
      label: 'Date',
    },
    description: {
      label: 'Motif',
    },
    recurring: {
      label: 'Récurrence annuelle',
    },
    created: {
      label: 'Créé',
      creator: 'par {{name}}',
    },
    updated: {
      label: 'Mis à jour',
    },
  },
  status: {
    closed: 'Fermé',
    open: 'Ouvert',
    paused: 'En pause',
  },
  date: {
    all_day: 'Toute la journée',
    paused_until_rest_of_day: "En pause jusqu'à la fin de la journée",
  },
  buttons: {
    pause_availability: '+ Suspendre la disponibilité',
    close_availability: '+ Fermer la disponibilité',
    amend_availability: '+ Modifier la disponibilité',
    sync_from_online_shop: 'Synchroniser depuis la boutique en ligne',
    close: 'Fermer',
    delete: 'Supprimer',
  },
  projects: {
    online_shop: 'Boutique en ligne',
    reservations: 'Réservations',
    storefront: 'Vitrine',
  },
  error_messages: {
    delete_failed: 'Échec de la suppression. Veuillez réessayer.',
  },
  toasts: {
    sync_success: 'Synchronisé avec succès',
    sync_error:
      "Échec de la synchronisation des exceptions d'horaires depuis la boutique en ligne. Veuillez réessayer.",
  },
};
